'use strict';
var util = require('../util');

module.exports = {
  appVersion: '7.9.4',
  setSpotlight: function (opt) {
    if (!opt.webpageURL) {
      return;
    }
    if (!opt.scheme) {
      opt.scheme = 'dianping://web?url=' + encodeURIComponent(opt.webpageURL);
    }
    this._send('setSpotlight', opt);
  },
  playVoice: util.actionMapping('playVoice')
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/dpapp/lib/patch/patch-7.9.4.js
// module id = 526
// module chunks = 0